import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import { authGuard } from "../auth/authGuard";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/throw',
      name: 'throw',
      component: () => import('../views/Throw.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('../views/Messages.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/Admin.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('../views/Activity.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/score',
      name: 'score',
      component: () => import('../views/Throw.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/ranking2',
      name: 'ranking2',
      component: () => import('../views/Ranking2.vue'),
    },
    {
      path: '/best',
      name: 'best',
      component: () => import('../views/Best.vue'),
    },

    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/Profile.vue'),
      beforeEnter: authGuard
    },

    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/Privacy.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/TermsOfService.vue')
    },
    {
      path: '/display',
      name: 'display',
      component: () => import('../views/Display.vue')
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('../views/Shop.vue')
    },

    {
      path: '/lanes/:lane_id',
      name: 'lanes',
      component: () => import('../views/LanesViewer.vue')
    },
    {
      path: '/scorecard/:scorecard_id',
      name: 'scorecard',
      component: () => import('../views/ScorecardViewer.vue')
    },
    {
      path: '/summary/:scorecard_id',
      name: 'summary',
      component: () => import('../views/SummaryViewer.vue')
    },

    {
      path: '/members',
      name: 'members',
      component: () => import('../views/Members.vue')
    },
    {
      path: '/uploadsolo',
      name: 'uploadsolo',
      component: () => import('../views/UploadSolo.vue'),
      beforeEnter: authGuard
    },

    /*,
    {
      path: '/event/:id',
      name: 'eventSingle',
      component: () => import('../views/EventSingle.vue')
    }*/
  ]
})

router.beforeEach((to, from, next) => {
  checkNav();
  next();
});

function checkNav() {
  //console.log("here");
  if (document.getElementById("burger-button")) {
    var expanded = (document.getElementById("burger-button").getAttribute('class').indexOf('is-active') == -1 ? false : true);
    if (expanded) {
      //console.log("close menu");
      document.getElementById("burger-button").click(); //classList.toggle("is-active");
    }
  }
}

export default router;